import { FeatureCategory } from '../types';

export const homeSafetyFeatures: FeatureCategory = {
  name: "Home Safety & Independence",
  icon: "ShieldHeart",
  features: [
    { 
      name: "Home Safety Checks", 
      description: "Use your phone camera to check rooms for fall hazards, lighting issues, clutter, and accessibility concerns. Get personalized safety recommendations.",
      starter: "5 Img", max: "Unlimited", family: "Unlimited", careAddOn: "👁"
    },
    { 
      name: "Room Safety Recommendations", 
      description: "Personalized safety recommendations based on your room checks, including specific improvements to reduce fall risk and enhance accessibility.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "Safety To-Dos & \"Get Help\" Options", 
      description: "Actionable safety to-do lists with options to get professional help for implementation of safety improvements.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "DIY Videos (YouTube)", 
      description: "Curated DIY videos from YouTube showing how to implement safety improvements and modifications yourself.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "DIY Fix-It Tips", 
      description: "Step-by-step instructions and tips for making simple safety improvements and home modifications.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "Amazon Product Links", 
      description: "Direct links to recommended safety products on Amazon for easy purchasing of grab bars, lighting, and other safety equipment.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "Thumbtack Pros Finder", 
      description: "Find local professionals on Thumbtack for home modifications, handyman services, and safety improvements.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "CAPS (Aging-in-Place) Pros Finder", 
      description: "Connect with Certified Aging-in-Place Specialists (CAPS) who are experts in home modifications for older adults.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "Occupational Therapist Finder", 
      description: "Find local occupational therapists who specialize in home safety assessments and aging-in-place modifications.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    }
  ]
};
